module.exports = "<h1 id=\"22-解除眩晕--スタン回復\">22. 解除眩晕 / スタン回復</h1>\n<WIP />\n\n<p><strong><code>StunRecover</code>。</strong>未出现过。</p>\n";